import $ from 'jquery';
import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.expandComment = function(e) {
        $(e.target).attr('data-state-expanded', true);
    };

    this.after('initialize', function() {
        this.on('focus', this.expandComment);
    });
});



// WEBPACK FOOTER //
// ./src/web/js/polls/modules/entry-comments.js